<template>
  <HeadlineComponent>Report: Crew Telefonliste</HeadlineComponent>
  <table class="table">
    <thead>
    <tr>
      <th>Name</th>
      <th>Telefonnummer</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="u of user" :key="u.id">
      <td>{{u.full_name}}</td>
      <td>{{u.phone_nice}}</td>
    </tr>
    </tbody>
  </table>

</template>

<script>
import userService from "@/services/user.service.js";
import {mapActions} from "pinia";
import {useAlertsStore} from "@/stores/alerts.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import * as Sentry from '@sentry/vue';

export default {
    name: "PhoneListView",
    data() {
        return {
            user: []
        };
    },
    methods: {
        ...mapActions(useAlertsStore, { addAlert: "add" })
    },
    async beforeRouteEnter(to, from, next) {
        let user = [];
        try {
            let response = await userService.index();
            user = response.data;
        }
        catch (e) {
            if (e) {
                Sentry.captureException(e);
                useAlertsStore().add("danger", "Es ist was unerwartetes schief gegangen..");
                window.scrollTo(0, 0);
            }
        }
        next(vm => {
            vm.user = user;
        });
    },
    components: { HeadlineComponent }
}
</script>

<style scoped>

</style>